import React, { Component } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Container } from "semantic-ui-react";
// import "react-super-responsive-table/src/SuperResponsiveTableStyle.css";

import "./home.css";
class AssignedJobsCard extends Component {
  genJob() {
    return this.props.jobs.map(job => {
      if (job.active) {
        return (
          <Tr>
            <Td textAlign="center">{job.derivative}</Td>
            <Td>{job.description}</Td>
            <Td textAlign="center">N/A</Td>
            <Td>03/29/2017</Td>
            <Td>
              <a color="blue">Update</a>
            </Td>
          </Tr>
        );
      }
    });
  }

  render() {
    return (
      <Container className="AssignedJobs" id="jobstablemobilecontainer">
        <Table columns={5} basic="very" id="jobstablemobile">
          <Thead>
            <Tr>
              <Th>WO #</Th>
              <Th>Description</Th>
              <Th>Remaining HRS</Th>
              <Th>Updated</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>{this.genJob()}</Tbody>
        </Table>
      </Container>
    );
  }
}

export default AssignedJobsCard;



// WEBPACK FOOTER //
// ./src/components/home-components/assignedjobsmobile.js